import { IPeopleTag } from "@interfaces/tag.interface";
import { IPeople } from "@interfaces/people.interface";
import { CompanyAvatar, CompanyAvatarSizes } from "@ui/Avatars/CompanyAvatar";
import { TagLabel } from "@ui/Content";

type Props = {
  item: IPeopleTag & Partial<IPeople>;
  showEmail?: boolean;
} & React.HTMLAttributes<HTMLElement>;

export const SuggestionPeople = ({ item, showEmail, ...rest }: Props) => {
  const displayName =
    item.first_name && item.last_name ? `${item.first_name} ${item.last_name}` : item.email;

  return (
    <div {...rest} className="flex min-w-0 cursor-pointer items-center gap-1 p-2">
      <CompanyAvatar
        classNames="rounded-full border flex-shrink-0 w-5 h-5"
        size={CompanyAvatarSizes.SMALL}
        userProps={{
          first_name: item.first_name,
          last_name: item.last_name,
          email: showEmail ? item.email : undefined,
        }}
        logoUrl={item.logo || item?.primary_company?.company.logo_url}
        showInitialsByDefault
      />
      <TagLabel>{displayName}</TagLabel>
    </div>
  );
};
